import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import api from './middleware/api';
import authReducer from '@/store/auth/reducers';
import filterReducer from '@/store/filter';
import modalReducer from '@/store/modal';
import paramsReducer from '@/store/params';
import globalReducer from '@/store/global';
import productReducer from '@/store/product';
import resourcesReducer from '@/store/resources/reducers';
import customerReducer from '@/store/customer';
import languageReducer from '@/store/language';
import { listApi } from '@/api/listApi';

const rootReducer = combineReducers({
  auth: authReducer,
  filter: filterReducer,
  modal: modalReducer,
  resources: resourcesReducer,
  params: paramsReducer,
  global: globalReducer,
  product: productReducer,
  customer: customerReducer,
  language: languageReducer,
  [listApi.reducerPath]: listApi.reducer,
});

// const store = createStore(
// 	rootReducer,
// 	composeWithDevTools(applyMiddleware(ReduxThunk)),
// );

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    // The custom `api` middleware is synchronous (see store/middleware/api.js), so RTK Query's
    // synchronous internal dispatch works regardless of order here.
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false })
      .concat(listApi.middleware)
      .concat(api),
});

export default store;
